import { FC } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import AutoSizeInputNumber from "src/components/AutoSizeInputNumber/AutoSizeInputNumber";

type PointsAmountType = {
  value?: number;
  onChange?: (value: number) => void;
  className?:string;
  unitLabel?:string;
  fullWidth?: boolean;
};

const PointsAmount: FC<PointsAmountType & any> = ({ value, onChange, className, unitLabel, fullWidth = true, ...props }) => {
  const { t } = useTranslation();
  return (
    <AutoSizeInputNumber
      value={value}
      onChange={(val) => onChange?.(Number(val))}
      minWidth={90}
      fullWidth={fullWidth}
      suffix={<span className="font-inter! font-semibold! text-font-active! leading-loose! w-full!">{unitLabel ?? t("PointsExchange.exchange.pointsSuffix")}</span>}
      classNames={{ input: "text-font-default!", root: "text-font-default" }}
      className={classNames("bg-background-minimal! p-2!", className)}
      {...props}
    />
  );
};

export default PointsAmount;
